import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { LoginScreen } from '@/screens/accounts/SCR-101-login'

// SCR-101 Sign in (accounts area).
export const Route = createFileRoute('/_public/login')({
  validateSearch: z.object({
    next: z.string().max(2000).optional().catch(undefined),
    signed_out: z.coerce.number().optional().catch(undefined),
    email: z.string().max(200).optional().catch(undefined),
    reset: z.coerce.number().optional().catch(undefined),
    error: z.string().max(200).optional().catch(undefined),
  }),
  component: function Login() {
    return <LoginScreen search={Route.useSearch()} />
  },
})
